import React from "react";
import { cn } from "../lib/utils"; // Adjust path if needed

const buttonVariants = (variant = "default", size = "default") => {
  const base =
    "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50";

  const variants = {
    default: "bg-blue-600 text-white hover:bg-blue-700",
    destructive: "bg-red-600 text-white hover:bg-red-700",
    outline: "border border-gray-300 bg-white hover:bg-gray-100",
    secondary: "bg-gray-100 text-black hover:bg-gray-200",
    ghost: "hover:bg-gray-100",
    link: "text-blue-600 underline-offset-4 hover:underline",
    custom: "bg-[#695ADB] text-white hover:bg-[#5a4fc4]",
    download:
      "text-white font-bold text-base px-8 py-5 rounded-xl border border-white shadow-[0_6px_0_rgba(255,255,255,0.4)] transform -translate-y-[3px] hover:translate-y-[-1px] active:translate-y-1 active:shadow-none transition-all duration-200 bg-transparent hover:bg-transparent",
    xp:
      "bg-[#6A5AE0] text-white font-bold rounded-xl shadow-[0_5px_0_#4F43A8] transform -translate-y-[2px] " +
      "flex items-center gap-2 hover:translate-y-[-1px] hover:bg-opacity-90 active:translate-y-1 active:shadow-none transition-all duration-200",
  };

  const sizes = {
    default: "h-10 px-4 py-2",
    sm: "h-9 rounded-md px-3",
    lg: "h-11 rounded-md px-8",
    icon: "h-10 w-10",
  };

  return cn(base, variants[variant], sizes[size]);
};

export const Button = React.forwardRef(
  ({ className, variant, size, children, href, ...props }, ref) => {
    const classes = cn(buttonVariants(variant, size), className);

    if (href) {
      return (
        <a
          ref={ref}
          href={href}
          className={classes}
          target="_blank"
          rel="noopener noreferrer"
          {...props}
        >
          {children}
        </a>
      );
    }

    return (
      <button ref={ref} className={classes} {...props}>
        {children}
      </button>
    );
  }
);

Button.displayName = "Button";
